import FormLogin from './FormLogin'

export {
  FormLogin
}


// WEBPACK FOOTER //
// ./src/components/FormLogin/index.js